import event_photo from "../images/Rectangle 20.png";
import photo2 from "../images/Rectangle 21.png";
import photo3 from "../images/Rectangle 22.png";
import photo4 from "../images/Rectangle 24.jpeg";
import photo5 from "../images/Rectangle25.png"
import photo6 from "../images/Rectangle26.png"
import photo7 from "../images/Rectangle27.png"
import photo8 from "../images/Rectangle28.png"
import { Link } from 'react-router-dom';
import { useState } from "react";

const products = [
  {
    id: 1,
    name: 'CV Summit 2023',
    imageSrc: event_photo,
    date: "3-5 October",
    price: '$35',
    location: 'Black',

  },
  {
    id: 2,
    name: 'Swiss Blockchain Capital Day',
    imageSrc: photo2,
    date: "3-5 October",
    price: '$35',
    location: 'Zurich, Zurich',

  },
  {
    id: 3,
    name: 'Blockchain Summit',
    imageSrc: photo3,
    date: "14-16 December",
    price: '$35',
    location: 'Dubai, UEA',

  },
  {
    id: 4,
    name: 'Coin Agenda EMEA',
    imageSrc: photo4,
    date: "18-22 January",
    price: '$150',
    location: 'Bangalore, India',

  },

  // More products...
]
const laters = [
  {
    id: 1,
    name: 'Blockchain Conference',
    imageSrc: photo5,
    date: "16 July 2024 ",
    price: '$35',
    location: 'Black',

  },
  {
    id: 2,
    name: 'Swiss Blockchain Capital Day',
    imageSrc: photo6,
    date: "3-5 October",
    price: '$35',
    location: 'Zurich, Zurich',

  },
  {
    id: 3,
    name: 'Blockchain Summit',
    imageSrc: photo7,
    date: "14-16 December",
    price: '$35',
    location: 'Dubai, UEA',

  },
  {
    id: 4,
    name: 'Coin Agenda EMEA',
    imageSrc: photo8,
    date: "18-22 January",
    price: '$150',
    location: 'Bangalore, India',

  },

  // More products...
]
export default function UpcomingEvents() {

  const [search, setSearch] = useState('');
  return (
    <div className="bg-background">
      <div className="mx-auto px-4 py-8 sm:px-8 sm:py-8 lg:px-8">
        <form className="my-5">
          <div class="relative grid grid-cols-3">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg class="w-4 h-4 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
              </svg>
            </div>
            <input type="search" id="default-search" 
            class="block w-full p-2 ps-10 text-sm text-white border border-white rounded-lg bg-background" 
            placeholder="Search Events"
            onChange={(e) => setSearch(e.target.value)}
            >
            </input>
          </div>
        </form>
        <h2 className="text-2xl font-title text-white">Upcoming Events</h2>
        <div className="mt-6 grid grid-cols-2 gap-x-6 gap-y-10 xs:grid-cols-2 xs:overflow-x-auto lg:grid-cols-4 xl:gap-x-8">
          {products.filter((product) => {
            return search.toLowerCase() === ''
              ? product
              : product.name.toLowerCase().includes(search);
          }).map((product) => (
            <Link
              to="/purchase"
              onClick={() => {
                window.scroll(0, 0);
              }}
            >
              <div key={product.id} className="group relative">
                <div className="aspect-w-1 w-full h-64 overflow-hidden bg-gray-200 lg:aspect-none group-hover:scale-105 transition duration-500 cursor-pointer lg:h-64">
                  <img
                    src={product.imageSrc}
                    className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                  />
                </div>
                <div className="mt-4 flex justify-between">
                  <div>
                    <h3 className="text-lg not-italic font-bold font-title leading-6 text-white">
                      <a href={product.href}>
                        <span aria-hidden="true" className="absolute inset-0" />
                        {product.name}
                      </a>
                    </h3>
                    <p className="mt-2 text-sm not-italic font-medium font-text leading-5 text-white">{product.date}</p>
                    <p className="mt-2 text-sm not-italic font-medium leading-5 font-text text-white">{product.location}</p>
                  </div>
                  <p className=" mt-10 pt-5 text-base not-italic font-bold font-text leading-6 text-blue">From {product.price}</p>
                </div>
              </div>
            </Link>

          ))}
        </div>
        <h2 className="text-2xl font-title mt-10 pt-5 text-white">Later This Year</h2>
        <div className="mt-6 grid grid-cols-2 gap-x-6 gap-y-10 xs:grid-cols-2 xs:overflow-x-auto lg:grid-cols-4 xl:gap-x-8">
          {laters.filter((later) => {
            return search.toLowerCase() === ''
              ? later
              : later.name.toLowerCase().includes(search);
          }).map((later) => (
            <Link
              to="/purchase"
              onClick={() => {
                window.scroll(0, 0);
              }}
            >
              <div key={later.id} className="group relative">
                <div className="aspect-w-1 w-full h-64 overflow-hidden bg-gray-200 lg:aspect-none group-hover:scale-105 transition duration-500 cursor-pointer lg:h-64">
                  <img
                    src={later.imageSrc}
                    className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                  />
                </div>
                <div className="mt-4 flex justify-between">
                  <div>
                    <h3 className="text-lg not-italic font-bold font-title leading-6 text-white">
                      <a href={later.href}>
                        <span aria-hidden="true" className="absolute inset-0" />
                        {later.name}
                      </a>
                    </h3>
                    <p className="mt-2 text-sm not-italic font-medium font-text leading-5 text-white">{later.date}</p>
                    <p className="mt-2 text-sm not-italic font-medium leading-5 font-text text-white">{later.location}</p>
                  </div>
                  <p className=" mt-10 pt-5 text-base not-italic font-bold font-text leading-6 text-blue">From {later.price}</p>
                </div>
              </div>
            </Link>

          ))}
        </div>
      </div>
    </div>
  )
}